/**
 * The session states (#26615). Exactly five; everything in flight (a refresh, a socket
 * authentication, a logout) is a single-flight promise inside the `SessionController`, not a state.
 *
 * | state       | meaning                                                                          |
 * |-------------|----------------------------------------------------------------------------------|
 * | starting    | process start, token and cache not yet read                                      |
 * | loggedOut   | no usable token, or the grant was rejected — the only state that leads to /login |
 * | online      | token valid and the socket authenticated with it                                 |
 * | offline     | a usable account (memory or cache), socket down or backend in maintenance        |
 * | degraded    | socket up, but the backend cannot be used right now — retries are running        |
 */
export type SessionState = 'starting' | 'loggedOut' | 'online' | 'offline' | 'degraded';

/** States in which the route guards let the user into the app (given an account). */
export const ACTIVE_STATES: ReadonlySet<SessionState> = new Set<SessionState>(['online', 'offline', 'degraded']);
